var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "toast" }, [
      _c("p", { staticClass: "toast-text" }, [
        _vm.icon === "info"
          ? _c(
              "svg",
              {
                staticClass: "toast-icon",
                attrs: {
                  width: "38",
                  height: "38",
                  viewBox: "0 0 38 38",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("g", { attrs: { filter: "url(#filter0_d_7623_32798)" } }, [
                  _c("circle", {
                    attrs: { cx: "19", cy: "15", r: "15", fill: "#FAFAFA" },
                  }),
                ]),
                _vm._v(" "),
                _c("circle", {
                  attrs: {
                    cx: "19.2766",
                    cy: "19.2766",
                    r: "1.2766",
                    fill: "#2E9FE7",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M19 7L19 15.2979",
                    stroke: "#2E9FE7",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _vm._v(" "),
                _c("defs", [
                  _c(
                    "filter",
                    {
                      attrs: {
                        id: "filter0_d_7623_32798",
                        x: "0",
                        y: "0",
                        width: "38",
                        height: "38",
                        filterUnits: "userSpaceOnUse",
                        "color-interpolation-filters": "sRGB",
                      },
                    },
                    [
                      _c("feFlood", {
                        attrs: {
                          "flood-opacity": "0",
                          result: "BackgroundImageFix",
                        },
                      }),
                      _vm._v(" "),
                      _c("feColorMatrix", {
                        attrs: {
                          in: "SourceAlpha",
                          type: "matrix",
                          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                          result: "hardAlpha",
                        },
                      }),
                      _vm._v(" "),
                      _c("feOffset", { attrs: { dy: "4" } }),
                      _vm._v(" "),
                      _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                      _vm._v(" "),
                      _c("feColorMatrix", {
                        attrs: {
                          type: "matrix",
                          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
                        },
                      }),
                      _vm._v(" "),
                      _c("feBlend", {
                        attrs: {
                          mode: "normal",
                          in2: "BackgroundImageFix",
                          result: "effect1_dropShadow_7623_32798",
                        },
                      }),
                      _vm._v(" "),
                      _c("feBlend", {
                        attrs: {
                          mode: "normal",
                          in: "SourceGraphic",
                          in2: "effect1_dropShadow_7623_32798",
                          result: "shape",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            )
          : _c(
              "svg",
              {
                staticClass: "toast-icon",
                attrs: {
                  width: "50",
                  height: "49",
                  viewBox: "0 0 141 140",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M31.1569 74.6869C29.7703 76.0735 28.7996 78.1537 28.6609 80.3724L0.234001 137.088C-0.182001 137.92 -0.0433335 138.891 0.650002 139.445C1.066 139.861 1.62067 140 2.17534 140C2.45267 140 2.86868 139.861 3.14601 139.723L59.8617 111.296C62.219 111.018 64.1602 110.186 65.5472 108.8C70.955 103.392 67.7658 91.605 58.1977 82.0368C48.6295 72.4687 36.7044 69.2795 31.1577 74.6873L31.1569 74.6869ZM40.0316 102.975L40.4476 103.391C40.8636 103.668 41.2796 104.084 41.557 104.362C41.6956 104.5 41.8343 104.639 41.973 104.639C42.5276 105.055 42.9436 105.471 43.4983 105.748L43.7756 106.026L45.0236 106.858C45.1623 106.996 45.301 106.996 45.4396 107.135C45.8556 107.412 46.2716 107.69 46.8263 107.967C46.965 107.967 46.965 108.106 47.1036 108.106C47.6583 108.383 48.213 108.66 48.629 108.938C48.7676 108.938 48.9063 109.076 49.045 109.076C49.461 109.215 49.877 109.492 50.293 109.631C50.4317 109.631 50.5703 109.77 50.709 109.77C51.2637 110.047 51.8183 110.186 52.2343 110.324L35.8716 118.506L26.0264 94.5159L29.4932 87.5826C29.4932 87.7213 29.4932 87.7213 29.6319 87.8599L30.0479 89.1079C30.0479 89.2466 30.1866 89.3853 30.1866 89.3853C30.4639 89.9399 30.6026 90.4946 30.8799 90.9106C30.8799 91.0493 31.0186 91.1879 31.0186 91.3266C31.1572 91.7426 31.4346 92.1586 31.7119 92.5746C31.8506 92.7133 31.8506 92.8519 31.9892 93.1293C32.2666 93.5453 32.4053 93.9613 32.6826 94.2386C32.8213 94.3773 32.8213 94.5159 32.9599 94.6546C33.2373 95.2093 33.6533 95.7639 34.0693 96.1799C34.0693 96.3186 34.2079 96.3186 34.2079 96.4573C34.4853 96.8733 34.9013 97.2893 35.1786 97.7053C35.3173 97.8439 35.4559 97.9826 35.5946 98.26C35.8719 98.676 36.1493 98.9533 36.5653 99.3693L36.9813 99.7853C37.3973 100.34 37.9519 100.756 38.3679 101.311C39.0613 102.004 39.6159 102.42 40.0319 102.975L40.0316 102.975ZM32.1274 120.586L20.6182 126.41L15.9035 114.9L23.5301 99.6469L32.1274 120.586ZM13.546 119.892L17.0129 128.351L6.75151 133.482L13.546 119.892ZM62.4963 105.887C61.6643 106.719 60.4163 107.135 58.891 107.273C54.0378 107.551 47.2429 104.223 41.5574 98.5374C40.8641 97.8441 40.1708 97.1508 39.4774 96.3188C35.0401 91.1879 32.4056 85.3642 32.6826 81.0654C32.8213 79.5401 33.2373 78.2921 34.0693 77.46C35.0399 76.4894 36.5653 75.9347 38.2293 75.9347C43.0825 75.9347 50.0161 79.8174 55.0081 84.8094C61.803 91.7428 66.3788 102.004 62.4962 105.887L62.4963 105.887Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M81.6312 76.2114C82.4632 76.3501 83.4339 75.934 83.8499 75.102C84.2659 74.27 84.1272 73.2994 83.4339 72.7447L78.3031 67.7527L81.4922 61.374C81.9082 60.542 81.7696 59.5713 81.0762 59.0167C80.3829 58.462 79.4122 58.1847 78.7189 58.6007L72.3402 61.7898L67.3482 56.7978C66.6549 56.1045 65.6842 55.9658 64.9909 56.3818C64.1589 56.7978 63.7429 57.6298 63.8815 58.6005L64.9909 65.6724L58.6122 68.8616C57.7802 69.2776 57.3642 70.1096 57.5028 71.0802C57.6415 72.0509 58.3348 72.6056 59.1668 72.7442L66.2387 73.8536L67.348 80.9254C67.4867 81.7574 68.1801 82.4508 69.0121 82.5894H69.2894C70.1214 82.5894 70.8147 82.1734 71.0921 81.4801L74.2812 75.1014L81.6312 76.2114ZM71.5084 71.9129L70.5377 73.9929L70.1217 71.7742C69.983 70.9422 69.2897 70.2489 68.4577 70.1102L66.239 69.6942L68.1804 68.7235C69.0124 68.3075 69.4284 67.4755 69.2897 66.5048L68.8737 64.2862L70.5377 65.9502C71.231 66.6435 72.2017 66.7822 72.8951 66.3662L74.9751 65.3955L74.0044 67.4755C73.5884 68.3075 73.7271 69.2782 74.4204 69.8329L76.0844 71.4969L73.8657 71.0809C72.7564 70.6649 71.9244 71.0809 71.5084 71.9129Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M86.6582 50.44L102.053 35.0456L104.994 37.9873L89.5999 53.3817L86.6582 50.44Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M112.512 24.7065L115.846 21.3721L118.788 24.3138L115.453 27.6482L112.512 24.7065Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M105.553 31.6859L108.887 28.3515L111.829 31.2932L108.494 34.6276L105.553 31.6859Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M112.525 31.3848L115.467 28.4431L118.8 31.7775L115.858 34.7192L112.525 31.3848Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M105.441 24.3199L108.383 21.3782L111.717 24.7113L108.776 27.653L105.441 24.3199Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M43.7753 64.9785L45.7166 65.8105C45.9939 65.1172 53.2046 48.477 43.9139 26.7048L40.0312 28.3688C48.6286 48.3369 41.9726 64.0071 41.9726 64.1465L43.7753 64.9785Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M76.086 47.0929C76.3633 46.5383 81.91 33.3651 77.4726 15.6157L73.4511 16.5863C77.4726 32.9491 72.3418 45.2903 72.2031 45.4291L76.086 47.0929Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M72.3424 12.7019H73.1744C74.5611 12.7019 75.8091 12.2859 76.9183 11.4539C78.305 10.4832 79.137 8.9579 79.4143 7.29389C79.6916 5.62988 79.2756 3.96588 78.1663 2.57921C77.057 1.19254 75.6703 0.360534 74.0063 0.0832003C72.3423 -0.194134 70.6783 0.221867 69.2916 1.3312C66.5183 3.41121 65.9636 7.43256 68.0436 10.2059C69.1529 11.5926 70.6783 12.5632 72.3421 12.7019H72.3424ZM71.7878 4.65921C72.2038 4.38188 72.6198 4.24321 73.1744 4.24321C73.8678 4.24321 74.5611 4.52055 74.9771 5.07522C75.3931 5.49122 75.5318 6.18455 75.3931 6.73922C75.2544 7.29389 74.9771 7.84856 74.5611 8.12589C74.1451 8.54189 73.4518 8.68056 72.8971 8.54189C72.3424 8.40323 71.7878 8.12589 71.5104 7.70989C70.6784 6.73922 70.9558 5.35255 71.7878 4.65921Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M36.0918 9.84085L38.6621 2.22034L42.6044 3.55005L40.0341 11.1706L36.0918 9.84085Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M30.6621 25.9965L33.2336 18.376L37.1759 19.7057L34.6044 27.3262L30.6621 25.9965Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M40.2344 18.174L41.5641 14.2317L49.1846 16.8032L47.8549 20.7455L40.2344 18.174Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M24.0781 12.7376L25.4091 8.79535L33.0296 11.3669L31.6986 15.3092L24.0781 12.7376Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M74.1426 94.376L75.8066 98.1198C75.9453 98.1198 91.6146 91.4638 111.584 100.061L113.248 96.1785C91.6162 86.888 74.9762 94.0985 74.1426 94.3758V94.376Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M93 64.0086L94.664 67.8913C94.8027 67.8913 107.144 62.622 123.507 66.6433L124.477 62.6218C106.728 58.1844 93.5548 63.7311 93.0002 64.0085L93 64.0086Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M137.514 61.7902C134.741 59.7102 130.719 60.2649 128.639 63.0382C126.559 65.8116 127.114 69.8331 129.887 71.9129C130.997 72.7449 132.383 73.1609 133.77 73.1609H134.602C136.266 72.8836 137.791 72.0516 138.762 70.6649C140.842 67.8916 140.287 64.0089 137.514 61.7902ZM135.434 68.3074C134.741 69.2781 133.354 69.4168 132.383 68.7234C131.413 68.0301 131.274 66.6434 131.967 65.6728C132.661 64.7021 134.047 64.5634 135.018 65.2568C135.989 65.9501 136.127 67.3368 135.434 68.3074Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M128.867 100.088L136.488 97.5161L137.817 101.458L130.197 104.03L128.867 100.088Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M112.672 105.634L120.291 103.06L121.622 107.001L114.003 109.575L112.672 105.634Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M119.295 92.3411L123.237 91.0114L125.807 98.6319L121.865 99.9616L119.295 92.3411Z",
                    fill: "white",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M124.811 108.401L128.753 107.072L131.324 114.692L127.382 116.022L124.811 108.401Z",
                    fill: "white",
                  },
                }),
              ]
            ),
        _vm._v(" "),
        _c("span", { domProps: { innerHTML: _vm._s(_vm.text) } }),
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "toast-close", on: { click: _vm.toastClose } },
        [
          _c(
            "svg",
            {
              staticClass: "close-icon",
              attrs: {
                width: "25",
                height: "25",
                viewBox: "0 0 25 25",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("g", { attrs: { filter: "url(#filter0_d_7623_32804)" } }, [
                _c("path", {
                  attrs: {
                    d: "M5 1L20 16",
                    stroke: "white",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    d: "M20 1L5 16",
                    stroke: "white",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("defs", [
                _c(
                  "filter",
                  {
                    attrs: {
                      id: "filter0_d_7623_32804",
                      x: "0",
                      y: "0",
                      width: "25",
                      height: "25",
                      filterUnits: "userSpaceOnUse",
                      "color-interpolation-filters": "sRGB",
                    },
                  },
                  [
                    _c("feFlood", {
                      attrs: {
                        "flood-opacity": "0",
                        result: "BackgroundImageFix",
                      },
                    }),
                    _vm._v(" "),
                    _c("feColorMatrix", {
                      attrs: {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha",
                      },
                    }),
                    _vm._v(" "),
                    _c("feOffset", { attrs: { dy: "4" } }),
                    _vm._v(" "),
                    _c("feGaussianBlur", { attrs: { stdDeviation: "2" } }),
                    _vm._v(" "),
                    _c("feComposite", {
                      attrs: { in2: "hardAlpha", operator: "out" },
                    }),
                    _vm._v(" "),
                    _c("feColorMatrix", {
                      attrs: {
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0",
                      },
                    }),
                    _vm._v(" "),
                    _c("feBlend", {
                      attrs: {
                        mode: "normal",
                        in2: "BackgroundImageFix",
                        result: "effect1_dropShadow_7623_32804",
                      },
                    }),
                    _vm._v(" "),
                    _c("feBlend", {
                      attrs: {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "effect1_dropShadow_7623_32804",
                        result: "shape",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }